import { axios } from '@/lib/axios';

import { SellCryptoInput } from '../components/SellCryptoForm';

export const sellCrypto = async (payload: SellCryptoInput) => {
  const resp = await axios.post('/crypto/sell', payload);

  return resp.data;
};
